import { createSlice } from "@reduxjs/toolkit";

const AuthSlice = createSlice({
	name: "auth",
	initialState: {
		isAuthenticated: false,
		authToken: "",
	},
	reducers: {
		setAuthValue: (state, action) => {
			// console.log(state.isAuthenticated)
			// state.isAuthenticated = true;
			console.log(state.isAuthenticated)
			console.log(state.authToken)

			state.authToken = action.payload;
			console.log(state.authToken)
		},
	},
});

export default AuthSlice;